// @purpose VIEW
// The mobile tab bar tucks away while reading down a page and returns on scroll up or near the top/bottom,
// so it never sits over the text being read (founder, 2026-10-13). CSS: layout.css `.tabbar.is-tucked`.
export function initTabbar() {
  let lastY = window.scrollY;
  let ticking = false;
  const update = () => {
    ticking = false;
    const bar = document.querySelector(".tabbar");
    if (!bar) return;
    const y = window.scrollY;
    const nearEdge = y < 80 || window.innerHeight + y > document.documentElement.scrollHeight - 80;
    if (nearEdge || y < lastY - 6) bar.classList.remove("is-tucked");
    else if (y > lastY + 6) bar.classList.add("is-tucked");
    lastY = y;
  };
  window.addEventListener("scroll", () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
}
